import type en from '../en/profile'
import type { Translation } from '../types'

/** My profile: language, contact, password and the person’s own settings */
const profile: Translation<typeof en> = {
  "profile.language": "Langue",
  "profile.languageHint": "La langue du tableau de bord et des messages que vous recevez. « Comme l’entreprise » suit la langue de votre entreprise.",
  "profile.sameAsCompany": "Comme l’entreprise",
  "profile.languageSaved": "Langue enregistrée",
  "profile.languageNotSaved": "Impossible d’enregistrer la langue",
  "profile.pwChanged": "Mot de passe modifié",
  "profile.pwChangedText": "Toutes les sessions ont été déconnectées ; ce navigateur s’est reconnecté.",
  "profile.pwFailed": "Le mot de passe n’a pas pu être modifié",
  "profile.pwCheck": "Vérifiez votre mot de passe actuel et réessayez.",
  "profile.vpnDownloaded": "Fichier VPN téléchargé",
  "profile.vpnDownloadedText": "Importez le fichier .ovpn dans votre client OpenVPN.",
  "profile.downloadFailed": "Échec du téléchargement",
  "profile.vpnNotYet": "Le fichier VPN n’est pas encore disponible.",
  "profile.title": "Mon profil",
  "profile.alertContact": "Contact pour les alertes",
  "profile.alertContactText": "Ajoutez un numéro de téléphone au format international pour recevoir les alertes de panne par WhatsApp ou RCS.",
  "profile.appearance": "Apparence",
  "profile.theme.light": "Clair",
  "profile.theme.dark": "Sombre",
  "profile.default": "(par défaut)",
  "profile.account": "Compte",
  "profile.companyAdmin": "Administrateur de l’entreprise",
  "profile.teamMember": "Membre de l’équipe",
  "profile.permissions": { one: "{count} droit", other: "{count} droits" },
  "profile.vpnAccess": "Accès VPN",
  "profile.lastSeen": "Vu pour la dernière fois",
  "profile.downloadVpn": "Télécharger le fichier .ovpn",
  "profile.vpnCreating": "Votre compte VPN est en cours de création. Cela prend généralement quelques minutes.",
  "profile.noVpn": "Pas encore de compte VPN.",
  "profile.setup": "Instructions d’installation",
  "profile.changePw": "Changer le mot de passe",
  "profile.currentPw": "Mot de passe actuel",
  "profile.hidePw": "Masquer le mot de passe",
  "profile.showPw": "Afficher le mot de passe",
  "profile.newPw": "Nouveau mot de passe",
  "profile.confirmPw": "Confirmer le mot de passe",
  "profile.updatePw": "Mettre à jour le mot de passe",
  "profile.phoneSaved": "Numéro de téléphone enregistré",
  "profile.phoneSaveFailed": "Le numéro n’a pas pu être enregistré",
  "profile.codeSent": "Code envoyé",
  "profile.codeSentRcs": "Consultez l’application de messages de ce téléphone (RCS).",
  "profile.codeSentWa": "Consultez WhatsApp sur ce numéro.",
  "profile.codeFailed": "Aucun code n’a pu être envoyé",
  "profile.phoneVerified": "Numéro de téléphone vérifié",
  "profile.verifyFailed": "Échec de la vérification",
  "profile.phone": "Numéro de téléphone",
  "profile.verified": "vérifié",
  "profile.notVerified": "non vérifié",
  "profile.save": "Enregistrer",
  "profile.sendAgain": "Renvoyer",
  "profile.sendCode": "Envoyer le code de vérification",
  "profile.code": "Code de vérification",
  "profile.codePlaceholder": "Code à 6 chiffres",
  "profile.verify": "Vérifier",
  "profile.verifiedOnly": "Les alertes WhatsApp et RCS ne sont envoyées qu’à un numéro vérifié.",
  "profile.phoneApp": "Application mobile",
  "profile.phoneAppAddress": "Dans l’application Velanox, choisissez « Se connecter à votre entreprise » et scannez ce code, ou saisissez l’adresse :",
  "profile.phoneAppSoon": "L’application arrive sur l’App Store et Google Play.",
  "profile.phones": "Téléphones qui restent connectés",
  "profile.noPhones": "Aucun téléphone ne reste connecté.",
  "profile.thisPhone": "Ce téléphone",
  "profile.phoneAdded": "ajouté {when}",
  "profile.phoneUsed": "dernière utilisation {when}",
  "profile.removePhoneOf": "Retirer {name}",
  "profile.removePhoneConfirm": "Retirer {name} ? Il est déconnecté et redemandera le mot de passe.",
  "profile.phoneRemoved": "Téléphone retiré",
  "profile.phoneRemoveFailed": "Le téléphone n’a pas été retiré",
  "profile.push.on": "Push : activé",
  "profile.push.off": "Push : désactivé",
  "profile.push.allow": "Autoriser les notifications push sur ce téléphone",
  "profile.push.turnOff": "Désactiver les notifications push",
  "profile.push.denied": "Les notifications push sont désactivées dans les réglages de ce téléphone",
  "profile.push.refused": "Les notifications push n'ont pas été autorisées sur ce téléphone",
  "profile.push.shortages": "Matériel manquant par notification push",
  "profile.push.shortagesHint": "Seulement vos téléphones : l'e-mail sur le matériel manquant reste inchangé.",
  "profile.push.notSaved": "Impossible d'enregistrer le réglage push",
  "profile.push.channel": "Alertes",
}

export default profile
